export const SETTINGS = 'SETTINGS';
export const ERRORS = 'ERRORS';
